import React from 'react';

import Checked from 'assets/icons/checked.svg';

type CheckButtonProps = {
  checked?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  id?: string;
};

function CheckButton({checked, onClick, ...props}: CheckButtonProps) {
  return (
    <div
      className={`disabled:opacity-75 w-6 h-6 focus:outline-none cursor-pointer select-none ${
        checked ? 'bg-dodger-blue' : 'bg-white border border-skyblue'
      }`}
      style={{borderRadius: 8}}
      onClick={onClick}
      {...props}
    >
      {checked ? (
        <div className="w-6 h-6">
          <img src={Checked} alt="checked" className="m-auto w-3 h-6" />
        </div>
      ) : (
        <div className="w-6 h-6" />
      )}
    </div>
  );
}

export default CheckButton;
